export function lodgingLinks(place: string, checkin: string, checkout: string) {
  const booking = new URL("https://www.booking.com/searchresults.it.html");
  booking.searchParams.set("ss", place);
  booking.searchParams.set("checkin", checkin);
  booking.searchParams.set("checkout", checkout);
  booking.searchParams.set("group_adults", "2");

  const airbnb = new URL("https://www.airbnb.it/s/homes");
  airbnb.searchParams.set("query", place);
  airbnb.searchParams.set("checkin", checkin);
  airbnb.searchParams.set("checkout", checkout);
  airbnb.searchParams.set("adults", "2");
  airbnb.searchParams.set("children", "4");
  return { booking: booking.toString(), airbnb: airbnb.toString() };
}
